import { createSlice } from '@reduxjs/toolkit';
export const aboutSlice = createSlice({
	name: 'about',
	initialState: {
		data: null,
	},
	reducers: {
		setAbout: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { setAbout } = aboutSlice.actions;
export default aboutSlice.reducer;
